import API from "../axiosConfig";

export const getAgentsStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.agent_id) params.agent_id = filters.agent_id;
    if (filters.sort_by) params.sort_by = filters.sort_by;

    const response = await API.get("/statistics/agents", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInfractionsStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.zone_id) params.zone_id = filters.zone_id;
    if (filters.type_infraction)
      params.type_infraction = filters.type_infraction;
    if (filters.group_by) params.group_by = filters.group_by;
    if (filters.date_field) params.date_field = filters.date_field;

    const response = await API.get("/statistics/infractions", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPaymentsStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }

    if (filters.group_by) params.group_by = filters.group_by;

    const response = await API.get("/statistics/payments", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getZonesStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }

    if (filters.zone_id) params.zone_id = filters.zone_id;

    const response = await API.get("/statistics/zones", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWarningsStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.zone_id) params.zone_id = filters.zone_id;
    if (filters.type_infraction)
      params.type_infraction = filters.type_infraction;
    if (filters.group_by) params.group_by = filters.group_by;

    const response = await API.get("/statistics/warnings", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTicketParkingStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.group_by) params.group_by = filters.group_by;

    const response = await API.get("/statistics/ticket-parking", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSubscriptionStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.group_by) params.group_by = filters.group_by;
    if (filters.subscription_type_id) params.subscription_type_id = filters.subscription_type_id;

    const response = await API.get("/statistics/subscriptions", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPaymentStatisticsByZone = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.zone_id) params.zone_id = filters.zone_id;

    const response = await API.get("/statistics/payments-by-zone", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVehicleStatistics = async (filters) => {
  try {
    const params = {};

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.max_results) params.max_results = filters.max_results;
    if (filters.type_infraction_id) params.type_infraction_id = filters.type_infraction_id;
    if (filters.status) params.status = filters.status;
    if (filters.zone_id) params.zone_id = filters.zone_id;
    if (filters.min_violations) params.min_violations = filters.min_violations;

    const response = await API.get("/statistics/vehicle-violations", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUnpaidMonthlySubscriptions = async (filters) => {
  try {
    const params = {};

    if (filters.month) params.month = filters.month;
    if (filters.year) params.year = filters.year;
    if (filters.show_all !== undefined && filters.show_all !== null && filters.show_all !== false) {
      params.show_all = filters.show_all;
    }

    const response = await API.get("/statistics/subscriptions/unpaid-monthly", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPaidMonthlySubscriptions = async (filters) => {
  try {
    const params = {};

    if (filters.month) params.month = filters.month;
    if (filters.year) params.year = filters.year;
    if (filters.show_all !== undefined && filters.show_all !== null && filters.show_all !== false) {
      params.show_all = filters.show_all;
    }

    const response = await API.get("/statistics/subscriptions/paid-monthly", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
